import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ensite/ensite/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ensite/ensite/packages/client/src/app/(static)/[locale]/root-static-layout.tsx");
